import React, { Suspense,lazy } from "react";
import AppRouter from "./router";
import "./App.css";

function App() {
  return <div className="App">
    <AppRouter />
  </div>;
}

export default App;
